module.exports = __webpack_public_path__ + "img/03_sub_no.1d720e3e.svg";